// Vite entry. Phase 1: imports styles + new pure modules, runs LS migration.
// Render code is still in /public/legacy.js (classic script). Phase 2 will migrate.

import './styles.css';
import { migrate } from './storage.js';
import { setLang, applyTranslations, onLangChange } from './i18n/index.js';
import { applyTheme, mountThemeToggle } from './theme.js';

migrate();
applyTheme(); // set data-theme before any paint

// Phase 1: lock language to English. i18n infra stays so dynamic strings
// like bonus tier labels can still flow through t().
setLang('en');

function bootChrome() {
  document.documentElement.lang = 'en';
  applyTranslations();
  // Insert theme toggle into header (where lang toggle used to live).
  const hdr = document.getElementById('hdr');
  if (hdr && !document.getElementById('theme-toggle')) {
    const spacer = hdr.querySelector('.hdr-spacer');
    const slot = document.createElement('div');
    slot.style.cssText = 'display:flex;align-items:center;margin:0 4px';
    if (spacer && spacer.nextSibling) hdr.insertBefore(slot, spacer.nextSibling);
    else hdr.appendChild(slot);
    mountThemeToggle(slot);
  }
  onLangChange(() => applyTranslations());
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootChrome, { once: true });
} else {
  bootChrome();
}

// Expose the new modules on window so legacy.js can opt-in to using them
// (only when convenient — full swap happens in Phase 2).
import * as calc    from './calc.js';
import * as fmt     from './format.js';
import * as roles   from './roles.js';
import * as state   from './state.js';
import * as perm    from './perm.js';
import * as storage from './storage.js';
import * as i18n    from './i18n/index.js';
import * as sanitize from './sanitize.js';
import * as config   from './config.js';
import * as api      from './api.js';
import * as authGsi  from './auth-gsi.js';
import { mountBuPerf, unmountBuPerf, visibleBUsFromPerm } from './bu-perf/mount.jsx';

window.__HD = { calc, fmt, roles, state, perm, storage, i18n, sanitize, config, api, authGsi };
window.__HD_BU = { mountBuPerf, unmountBuPerf, visibleBUsFromPerm };
// Convenience aliases used by legacy.js render code (interpolating into innerHTML).
window.HD_esc  = sanitize.escapeHtml;
window.HD_attr = sanitize.escapeAttr;

// GAS-auth boot: replace the PIN gate with the Google Sign-In button.
if (config.USE_GAS_AUTH) {
  const start = async () => {
    const gate = document.getElementById('pin-gate');
    if (!gate) return;
    try {
      const session = await authGsi.signIn(gate);
      // Hand role into legacy code so it skips the role-selector flow.
      window.__HD_SESSION = session;
      gate.style.display = 'none';
      // Legacy code listens for this to bypass PIN entry; fall through if missing.
      try { window.dispatchEvent(new CustomEvent('hd:authed', { detail: session })); } catch {}
    } catch (err) {
      console.error('[auth] sign-in failed', err);
      gate.innerHTML = `<div style="color:#f85149;font-size:11px;text-align:center;font-family:var(--f)">${sanitize.escapeHtml(String(err))}</div>`;
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
}
